<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width: 40px; padding-left: 10px">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="2">
            <el-select
              v-model="masterList.tableQuery.type"
              placeholder="报告类型"
              clearable
              style="width: 100%;"
              @keyup.enter.native="searchData()"
            >
              <el-option
                label="周报"
                value="1"
              />
              <el-option
                label="月报"
                value="2"
              />
              <el-option
                label="年报"
                value="4"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.provinceName"
              placeholder="请输入省区名称"
              style="width: 100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.cityName"
              placeholder="请输入市场名称"
              style="width: 100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.periodName"
              placeholder="请输入周期名称"
              style="width: 100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top: 5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="handleAdd"
        @edit="handleEdit(arguments)"
        @verify="handleVerify(arguments)"
        @analysis="handleAnalysis(arguments)"
        @publish="handlePublish(arguments)"
        @revoke="handleRevoke(arguments)"
        @delete="handleDelete(arguments)"
        @view="handleView(arguments)"
        @dblclick="handleView(arguments)"
        @preview="handlePreview(arguments)"
        @export="batchExport(masterList)"
        @download="handleDownloadJson(arguments)"
      />
    </div>

    <!-- 新增 -->
    <add-dialog
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogAddVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />

    <!-- 修改 -->
    <edit-dialog
      :data-id="id"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogViewVisible"
      :master-table-key="masterList.tableKey"
    />

    <!-- 报告数据验证结果显示弹框 -->
    <el-dialog
      v-if="dialogVerifyResultVisible"
      title="市场报告数据验证结果"
      :visible.sync="dialogVerifyResultVisible"
      destroy-on-close
      append-to-body
      class="h600_dialog"
      width="700px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="verify-result">
        <el-row v-if="verifyResultData.marketPriceZeroProductList.length > 0">
          <el-col
            v-for="(item, index) in verifyResultData.marketPriceZeroProductList"
            :key="'PriceZeroProduct_' + index"
            :span="24"
          >
            <el-alert
              :title="'品规：' + item + ' 集市交易价未采集'"
              type="error"
              show-icon
              :closable="false"
            />
          </el-col>
        </el-row>
        <el-row v-if="verifyResultData.marketPriceDifferenceProductList.length > 0">
          <el-col
            v-for="(item, index) in verifyResultData.marketPriceDifferenceProductList"
            :key="'PriceDiffWarningProduct_' + index"
            :span="24"
          >
            <el-alert
              :title="item"
              type="warning"
              show-icon
              :closable="false"
            />
          </el-col>
        </el-row>
        <el-row v-if="verifyResultData.sequentialWarningProductList.length > 0">
          <el-col
            v-for="(item, index) in verifyResultData.sequentialWarningProductList"
            :key="'PriceSequentialWarningProduct_' + index"
            :span="24"
          >
            <el-alert
              :title="item"
              type="warning"
              show-icon
              :closable="false"
            />
          </el-col>
        </el-row>
      </div>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVerifyResultVisible = !dialogVerifyResultVisible">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 新增
import addDialog from './components/addDialog'
// 修改
import editDialog from './components/editDialog'
// 查看
import viewDialog from './components/viewDialog'
// 数据请求
import { loadMarketReportListDataApi, exportMarketReportListDataApi, sendMarketReportToAIApi, updateMarketReportStatusApi, deleteMarketReportApi, verifyMarketReportApi, downloadJsonMarketReportApi } from '@/api/v2/marketReport'

export default {
  name: 'MarketReport',
  components: {
    CustomTable2,
    TableOperation2,
    addDialog,
    editDialog,
    viewDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data() {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'market_report_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['market_week_report_add'],
            prop: 'add',
            label: '新增',
            method: 'add'
          },
          {
            permissionSigns: ['market_week_report_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['market_week_report_edit'],
            prop: 'verify',
            label: '验证报告数据',
            method: 'verify'
          },
          {
            permissionSigns: ['market_week_report_edit'],
            prop: 'analysis',
            label: 'AI数据处理',
            method: 'analysis'
          },
          {
            permissionSigns: ['market_week_report_publish'],
            prop: 'publish',
            label: '发布',
            method: 'publish'
          },
          {
            permissionSigns: ['market_week_report_publish'],
            prop: 'revoke',
            label: '撤回',
            method: 'revoke'
          },
          {
            permissionSigns: ['market_week_report_del'],
            prop: 'delete',
            label: '作废',
            method: 'delete'
          },
          {
            permissionSigns: ['market_week_report_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['market_week_report_view'],
            prop: 'export',
            label: '导出',
            method: 'export'
          },
          {
            permissionSigns: ['market_week_report_view'],
            prop: 'download',
            label: '下载报告JSON数据',
            method: 'download'
          },
          {
            permissionSigns: ['market_week_report_view'],
            prop: 'preview',
            label: '预览市场报告',
            method: 'preview'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          type: '',
          provinceName: '',
          cityName: '',
          periodName: ''
        }
      },
      // 选中的单据ID
      id: null,
      eventType: '',
      dialogTitle: '',
      // 新增
      dialogAddVisible: false,
      // 修改
      dialogEditVisible: false,
      // 查看
      dialogViewVisible: false,
      // 验证数据结果显示
      dialogVerifyResultVisible: false,
      verifyResultData: {}
    }
  },
  created() {
    let _this = this
    // 初始化主列表Table列
    _this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'typeValue', filterColumn: "(case tmwr.type when 1 then '报告' when 2 then '月报' when 3 then '年报' when 4 then '季报' else '' end)", label: '类型', width: 80 },
      { prop: 'provinceName', filterColumn: 'tmwr.province_name', label: '省区', width: 100 },
      { prop: 'cityName', filterColumn: 'tmwr.city_name', label: '市场', width: 120 },
      { prop: 'periodName', filterColumn: 'tmrp.name', label: '期数', width: 80 },
      { prop: 'name', label: '报告名称', width: 240 },
      { prop: 'sampleOfflineNum', filterColumn: 'tmwr.sample_offline_num', label: '线下样本数量', width: 130 },
      { prop: 'sampleOnlineNum', filterColumn: 'tmwr.sample_online_num', label: '线上样本数量', width: 130 },
      { prop: 'overallStrategy', filterColumn: 'tmwr.overall_strategy', label: '整体策略', width: 300 },
      { prop: 'riskWarning', filterColumn: 'tmwr.risk_warning', label: '风险预警', width: 300 },
      { prop: 'statusValue', filterColumn: "(case tmwr.status when 1 then '草稿' when 2 then '发布' else '' end)", label: '状态', width: 80 },
      { prop: 'operatorName', filterColumn: 'tmwr.operator_name', label: '操作人', width: 100 },
      { prop: 'operationTime', filterColumn: 'tmwr.operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    _this.getInitTableColumns()
    _this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData() {
      let _this = this
      loadMarketReportListDataApi(_this.masterList.tableQuery).then((response) => {
        const { data } = response
        _this.handleData(data.list || [])
        _this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    //新增
    handleAdd() {
      let _this = this
      _this.dialogTitle = '创建市场报告'
      _this.dialogAddVisible = !_this.dialogAddVisible
    },
    // 修改
    handleEdit(args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的市场报告', type: 'warning' })
        return
      }
      if (args[0].status === 2) {
        _this.$message({ message: '该市场报告已发布，不能修改', type: 'warning' })
        return
      }

      _this.id = args[0].id
      _this.dialogTitle = '修改市场报告'
      _this.dialogEditVisible = !_this.dialogEditVisible
    },
    // 验证报告数据合法性
    handleVerify(args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要进行数据验证的市场报告', type: 'warning' })
        return
      }

      _this.$confirm('是否确定对市场报告数据进行验证？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        verifyMarketReportApi({ id: args[0].id }).then((response) => {
          const { data } = response
          if (data.verifyResult) {
            _this.$message({ message: '报告数据验证通过', type: 'success' })
          } else {
            _this.verifyResultData = {
              marketPriceZeroProductList: data.marketPriceZeroProductList || [],
              marketPriceDifferenceProductList: data.marketPriceDifferenceProductList || [],
              sequentialWarningProductList: data.sequentialWarningProductList || []
            }
            _this.dialogVerifyResultVisible = !_this.dialogVerifyResultVisible;
          }
        })
      }).catch(() => { })
    },
    // 提交AI智能体分析报告数据
    handleAnalysis(args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要提交AI智能体数据分析的市场报告', type: 'warning' })
        return
      }

      _this.$confirm('是否确定发送市场报告数据到AI进行分析？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        sendMarketReportToAIApi({ id: args[0].id, status: 2 }).then(() => {
          _this.$message({ message: '发送AI成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 查看
    handleView(args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的市场报告', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogTitle = '查看市场报告'
      _this.dialogViewVisible = !_this.dialogViewVisible
    },
    // 发布
    handlePublish(args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要发布的市场报告', type: 'warning' })
        return
      }
      if (args[0].status === 2) {
        _this.$message({ message: '该市场报告已发布，请勿重复操作', type: 'warning' })
        return
      }

      _this.$confirm('是否确定发布该市场报告？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateMarketReportStatusApi({ id: args[0].id, status: 2 }).then(() => {
          _this.$message({ message: '发布成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 撤回
    handleRevoke(args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要撤回的市场报告', type: 'warning' })
        return
      }
      if (args[0].status === 1) {
        _this.$message({ message: '该市场报告未发布，不能操作', type: 'warning' })
        return
      }
      _this.$confirm('是否确定撤回该市场报告？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        updateMarketReportStatusApi({ id: args[0].id, status: 1 }).then(() => {
          _this.$message({ message: '撤回成功', type: 'success' })
          _this.loadTableData()
        })
      })
    },
    // 作废
    handleDelete(args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要作废的市场报告', type: 'warning' })
        return
      }
      if (args[0].status === 2) {
        _this.$message({ message: '该市场报告已发布，不能作废', type: 'warning' })
        return
      }
      _this.$confirm('是否确定作废该市场报告？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        deleteMarketReportApi({ id: args[0].id, status: 0 }).then(() => {
          _this.$message({ message: '作废成功', type: 'success' })
          _this.loadTableData()
        })
      }).catch(() => { })
    },
    // 下载报告JSON数据
    handleDownloadJson(args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要下载的市场报告', type: 'warning' })
        return
      }
      _this.$confirm('是否确定下载该市场报告JSON数据？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
        downloadJsonMarketReportApi({ id: args[0].id }).then((response) => {
          const { data } = response

          // 将选中的数据转换为JSON字符串
          const jsonData = JSON.stringify(data, null, 2)
          // 创建一个Blob对象
          const blob = new Blob([jsonData], { type: 'application/json;charset=utf-8' })

          // 创建一个临时的a标签用于下载
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${data.title}.json`
          link.click()

          // 释放URL对象
          URL.revokeObjectURL(link.href)
        })
      }).catch(() => { })
    },
    // 预览市场报告
    handlePreview(args) {
      let _this = this
      if (!args[0]) {
        _this.$message({ message: '请选择要预览的市场报告', type: 'warning' })
        return
      }
      downloadJsonMarketReportApi({ id: args[0].id }).then((response) => {
        const { data } = response

        const previewWindow = window.open('report_preview.html', '_blank')
        previewWindow.onload = () => {
          previewWindow.postMessage(
            {
              type: 'reportData',
              data: data
            },
            '*'
          )
        }
      })
    },
    // 导出数据API
    exportByPage() {
      let _this = this
      exportMarketReportListDataApi(_this.exportObj).then((response) => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.verify-result {
  .el-col {
    min-height: 42px;
  }
}
</style>
